'use client';

import { tsrShared } from '@/libs/ts-rest/ts-rest';
import { createDistrictListQueryOptions } from '@/modules/shared/contracts';
import type { DistrictListQueryOptions } from '@/modules/shared/contracts';

export const useDistrictListQuery = (provinceId?: string, options?: Partial<DistrictListQueryOptions>) => {
	const queryOptions = createDistrictListQueryOptions(provinceId);

	return tsrShared.locations.district.list.useQuery({
		...queryOptions,
		...options,
	});
};
